/**
 * Strip leading game TFS / UI tokens from a unit display name for patch diff only.
 * Localisation used to prefix names with keys from UICommonUnitNameResources (#CMD, #RECO1, …).
 */
export function stripTfsPrefixFromUnitDisplayName(name: string): string {
  let s = name.trim();
  // Remove one or more leading "#Word" chunks and following whitespace (e.g. "#RECO2 ").
  const prefix = /^\s*#\w+\s+/u;
  while (prefix.test(s)) {
    s = s.replace(prefix, '').trimStart();
  }
  return s.trim();
}
